const SortAlphabetically = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66016 5.0683C2.66016 4.64226 3.00554 4.29688 3.43158 4.29688H19.7129C20.139 4.29688 20.4843 4.64226 20.4843 5.0683C20.4843 5.49435 20.139 5.83973 19.7129 5.83973H3.43158C3.00554 5.83973 2.66016 5.49435 2.66016 5.0683ZM2.66016 9.71926C2.66016 9.29321 3.00554 8.94783 3.43158 8.94783H15.882C16.3081 8.94783 16.6534 9.29321 16.6534 9.71926C16.6534 10.1453 16.3081 10.4907 15.882 10.4907H3.43158C3.00554 10.4907 2.66016 10.1453 2.66016 9.71926ZM2.66016 14.3702C2.66016 13.9442 3.00554 13.5988 3.43158 13.5988H12.4292C12.8552 13.5988 13.2006 13.9442 13.2006 14.3702C13.2006 14.7963 12.8552 15.1416 12.4292 15.1416H3.43158C3.00554 15.1416 2.66016 14.7963 2.66016 14.3702Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5234 12.8041C17.8694 12.0236 18.9769 12.0236 19.3229 12.8041L22.1276 19.1304C22.3003 19.5199 22.1245 19.9756 21.735 20.1483C21.3455 20.3209 20.8898 20.1452 20.7171 19.7557L20.0636 18.2816H16.7827L16.1292 19.7557C15.9565 20.1452 15.5008 20.3209 15.1113 20.1483C14.7218 19.9756 14.5461 19.5199 14.7187 19.1304L17.5234 12.8041ZM17.4667 16.7387H19.3796L18.4232 14.5814L17.4667 16.7387Z"
    />
  </>
);

export default SortAlphabetically;
